import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    // overrides
    static values = {
        tab: String
    }

    toggle(event) {
        // Disable tab functionality if the tab has no data-tab, used for buttons as tabs.
        if (!event.currentTarget.getAttribute('data-tab')) {
            return;
        }

        console.log(this.tabValue)

        for (const tabInner of this.element.querySelectorAll(this.hasTabValue ? this.tabValue : '.tab')) {
            tabInner.classList.remove('active');
        }

        for (const tabContent of this.element.querySelectorAll('.tab-content')) {
            tabContent.classList.remove('active');
        }

        for (const content of this.element.querySelectorAll('.' + event.currentTarget.getAttribute('data-tab'))) {
            content.classList.add('active');
        }

        event.currentTarget.classList.add('active');
    }
}
